<template>
  <div class="container-features">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
      <div class="box"> 
        <div class="box-header">
          <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
            <div>
              <img class="logo-test" src="../../assets/logo.png">
            </div>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
            <h2>Hvala za reševanje ankete s pomočjo aplikacije eQuiz!</h2>
            <h3>Kaj je eQuiz?</h3>
            <p>Je spletna in mobilna aplikacija v razvoju na Fakulteti za računalništvo in informatiko v Ljubljani.</p>
            <p>Ustvarjena je za prenos znanja iz miz, zasutih s knjigami in zvezki, v izzive dostopne kjerkoli in kadarkoli.</p>
            <h3>Komu je namenjen?</h3>
            <p>Namenjena je vsem <span class="text-light-blue">pedagogom</span>, ki želijo svojim <span class="text-green">učencem</span> ali  
            <span class="text-green">dijakom</span> omogočiti nove in interaktivne oblike izobraževanja in sprotnega dela.</p>
            <h3>Kontakt</h3>
            <p>Equiz je še v izdelavi. Za prejemanje najnovejših informacij o aplikaciji prosim vpišite svoj email.</p>
            <div class="input-group input-group-sm">
              <input type="email" class="form-control skin-blue" v-model="email">
                  <span class="input-group-btn">
                    <button type="button" class="btn btn-primary btn-flat" @click.prevent="subscribe()">Naroči se!</button>
                  </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
      <div class="box box-success feature">
        <div class="box-header with-border">
          <dt>
            Enostavno reševanje nalog
          </dt>
        </div>
        <div class="box-body">
          <dd>
            Učenec oziroma dijak enostavno in hitro rešuje naloge, s možnostjo uporabe namigov in rešitev ob nastopu težav, tako na mobilnem telefonu kot v spletnem brskalniku.
          </dd>
        </div>
      </div>
    </div>
    <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
      <div class="box box-success feature">
        <div class="box-header with-border">
          <dt>
            Vodeno nadgrajevanje znanja
          </dt>
        </div>
        <div class="box-body">
          <dd>
            Postopno nadgrajuje in utrjuje znanje z zaporedjem kvizov in izzivov. Omogočen lahek pregled nad že osvojenim znanjem in hiter dostop do novih izzivov.
          </dd>
        </div>
      </div>
    </div>
    <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
      <div class="box box-success feature">
        <div class="box-header with-border">
          <dt>
            Spremljanje in vzpodbujanje napredka
          </dt>
        </div>
        <div class="box-body">
          <dd>
            Ima podroben vpogled v lastno zgodovino reševanja. Aplikacija vzpodbuja in usmerja uporabo s izkušenjskimi točkami, nivoji in tekmovanjem s prijatelji.
          </dd>
        </div>
      </div>
    </div>
    <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
      <div class="box box-primary feature">
        <div class="box-header with-border">
          <dt>
            Upravljanje knjižnice nalog
          </dt>
        </div>
        <div class="box-body">
          <dd>
            Kot skrbnik skupine lahko enostavno uvažate naloge različnih formatov. Možno njihovo urejanje in dodajanje novih v temu namenjenemu urejevalniku. 
          </dd>
        </div>
      </div>
    </div>
    <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
      <div class="box box-primary feature">
        <div class="box-header with-border">
          <dt>
            Ustvarjanje drevesa nalog
          </dt>
        </div>
        <div class="box-body">
          <dd>
            Hitro delite naloge in kvize po skupinah in poljubno številnih podskupinah. Prilagajate svoj drevo nalog čim hitrejšemu postopnemu napredovanju učencev oziroma dijakov.
          </dd>
        </div>
      </div>
    </div>
    <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
      <div class="box box-primary feature">
        <div class="box-header with-border">
          <dt>
            Uspešnost kvizov in izpitov
          </dt>
        </div>
        <div class="box-body">
          <dd>
            Enostaven vpogled v statistiko reševanja kviza uporabnikov. Vsebuje pregled nad povprečno uspešnostjo posameznih nalog in neposredno do mnenj reševalcev.
          </dd>
        </div>
      </div>
    </div>
    <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
      <div class="box box-primary feature">
        <div class="box-header with-border">
          <dt>
            Sledenje uspešnosti letnika
          </dt>
        </div>
        <div class="box-body">
          <dd>
            Podroben pregled statistične uspešnosti tekočega letnika. Aktivnost uporabnikov, njihov skupni napredek in uspeh v primerjavi z minulimi letniki.
          </dd>
        </div>
      </div>
    </div>
    <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
      <div class="box box-primary feature">
        <div class="box-header with-border">
          <dt>
            Komunikacija z uporabniki
          </dt>
        </div>
        <div class="box-body">
          <dd>
            Enostavno komuniciranje in lahko prilagajanje željam uporabnikom s sistemom ocenjevanja nalog in kvizov, ter poročanjem napak.
          </dd>
        </div>
      </div>
    </div>
    <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
      <div class="box box-primary feature">
        <div class="box-header with-border">
          <dt>
            Avtomatizirano ustvarjanje izpitov
          </dt>
        </div>
        <div class="box-body">
          <dd>
            Aplikacija vsebuje sistem statistično podprtega pridobivanja znanja o učencih oziroma dijakih in nalogah, ki avtomatizira proces ustvarjanja kvizov in izpitov s primerno težavnostjo, časovnim vložkom in zahtevanim znanjem.
          </dd>
        </div>
      </div>
    </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      email: ''
    }
  },
  methods: {
    subscribe () {
      console.log(this.email)
    }
  }
}
</script>
<style>
.container-features {
  margin: 0 auto;
  width: 90%;
}

.title.center {
  margin-left: auto;
  margin-right: auto;
  text-align: center;
}

.feature-title {
  text-transform: uppercase;
  font-weight: 700;
}

dt {
  text-transform: uppercase;
  font-size: 0.95em;
  letter-spacing: 0.01em;
  margin-top: 0.5em;
}

.feature {
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 6em;
}

.box.feature {
  text-align: center;
  height: 13em;
  margin-bottom: 2em;
}

img {
    display: block;
    margin-left: auto;
    margin-right: auto;
}

.logo-test {
  margin-bottom: auto;
  width: auto;
  height: 22em;
}
</style>



// WEBPACK FOOTER //
// Features.vue?c8e1ca4a